import '../../App.css';
import '../../css/GeneralActivity.css'
import '../../css/BlueActivities.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from 'react-router-dom';
import {useContext, useEffect, useState} from 'react';
import Instructions from '../../baseElements/Instructions'
import TopBar from '../../baseElements/TopBar';
import {activity_palettes} from '../../themes';
import axios from 'axios';
import ConfirmButton from "../../baseElements/ConfirmButton";
import SadFeedback from "../../baseElements/SadFeedback";
import HappyFeedback from "../../baseElements/HappyFeedback";
import AnimationOverlay from "../../baseElements/AnimationOverlay";
import {AppContext} from "../../AppContext";
import {checkActivityStatus, delay, generateUrl, getExerciseFromDB, getLog, randomizeWords, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import NextExerciseButton from "../../baseElements/NextExerciseButton";
import NextQuestionButton from "../../baseElements/NextQuestionButton";
import StartExerciseButton from "../../baseElements/StartExerciseButton";
import Spinner from "react-bootstrap/Spinner";

axios.defaults.withCredentials = true;
const BACKGROUND_STYLE = activity_palettes.blue.secondary;

function FastRead() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    
    const [words, setWords] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [stepInfo, setStepInfo] = useState(1);
    const [levelInfo, setLevelInfo] = useState(0);
    const [instructionAudioUrl, setInstructionAudioUrl] = useState('');
    const [timeout, setCustomTimeout] = useState(1000);
    const [loading, setLoading] = useState(false);
    
    const [writtenWord, setWrittenWord] = useState('');
    const [currentWord, setCurrentWord] = useState({id: 0, name: ''});
    const [answered, setAnswered] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [wordColor, setWordColor] = useState('white');
    const [wordBackground, setWordBackground] = useState('#3851C4');
    const [isWordVisible, setIsWordVisible] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const [InstructionText, setInstructionText] = useState('Leggi la parola e scrivila nel riquadro');
    const [flowButtons, setFlowButtons] = useState({confirm: false, nextExercise: false, nextQuestion: false, startExercise: true});
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    function updateButtonFlow(showConfirm, showNextExercise, showNextWord, showStartExercise) {
        setFlowButtons({confirm: showConfirm, nextExercise: showNextExercise, nextQuestion: showNextWord, startExercise: showStartExercise});
    }
    
    function resetStates() {
        setWords([]);
        setMaxSteps(0);
        setStepInfo(1);
        setWrittenWord('');
        setCurrentWord({id: 0, name: ''});
        setAnswered(false);
        setFeedback('');
        setWordColor('white');
        setWordBackground('#3851C4');
        setIsWordVisible(false);
        setIsAnimating(false);
        setInstructionText('Leggi la parola e scrivila nel riquadro');
        setFlowButtons({confirm: false, nextExercise: false, nextQuestion: false, startExercise: true});
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home');
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    useEffect(() => {
        resetStates();
    }, [navigate]);
    
    function handleStartExerciseClick() {
        setLoading(true);
        loadExercise()
            .then((wordsTemporary) => {
                if (wordsTemporary.length > 0) {
                    syncExerciseWithDB(wordsTemporary)
                        .then(() => {
                            setLoading(false)
                        });
                } else {
                    console.error('No words loaded');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error('Error during loading or syncing:', error);
                setLoading(false);
            });
        
        updateButtonFlow(true, false, false, false);
    }
    
    async function loadExercise() {
        await delay(750);
        return getExerciseFromDB(activityList)
            .then((response) => {
                if (response.success) {
                    const json = JSON.parse(JSON.stringify(response.data[4]));
                    const level = JSON.parse(JSON.stringify(response.data[3]));
                    let wordsTemporary = [];
                    
                    if ("lettura_modulata" in json) {
                        setCustomTimeout(json.lettura_modulata.time);
                        json.lettura_modulata.parts.forEach((activity) => {
                            wordsTemporary.push({id: activity.id, name: activity.solution});
                        });
                    } else if ("lettura_modulata_morfo" in json) {
                        setCustomTimeout(json.lettura_modulata_morfo.time);
                        json.lettura_modulata_morfo.parts.forEach((activity) => {
                            wordsTemporary.push({id: activity.id, name: activity.solution});
                        });
                    }
                    
                    generateUrl("lettura modulata").then((url) => {
                        setInstructionAudioUrl(url)
                    });
                    
                    wordsTemporary = randomizeWords(wordsTemporary);
                    
                    wordsTemporary.forEach((word, index) => {
                        word.id = index;
                    });
                    
                    setWords(wordsTemporary);
                    setMaxSteps(wordsTemporary.length);
                    setLevelInfo(level);
                    
                    return wordsTemporary;
                } else {
                    console.error(response.errorMess);
                    return [];
                }
            })
            .catch((error) => {
                console.error('Error in loadExercise:', error);
                return [];
            });
    }
    
    function syncExerciseWithDB(wordsTemporary) {
        return new Promise((resolve) => {
            getLog(currentActivity).then((response) => {
                if (response.success) {
                    const exercises = JSON.parse(JSON.stringify(response.data))[0];
                    if (exercises.some((exercise) => exercise.exercise_id === exerciseId)) {
                        const exercise = exercises.find((exercise) => exercise.exercise_id === exerciseId);
                        let partId = -1;
                        exercise.actions.forEach((action) => {
                            if (action.part_id > partId) {
                                partId = action.part_id;
                            }
                        });
                        partId++;
                        
                        setExerciseLog(exercise);
                        setCurrentWord(wordsTemporary[partId]);
                        setStepInfo(partId + 1);
                        setIsWordVisible(true);
                    }
                } else {
                    console.log(response.data.errorMess);
                }
                resolve();
            });
        });
    }
    
    
    function logUserAction(correct) {
        const progress = (currentWord.id + 1) / words.length * 100;
        const timestamp = new Date().toISOString();
        const newAction = {
            part_id: currentWord.id,
            writtenWord: writtenWord,
            correct: correct,
            timestamp: timestamp,
        };
        
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: Math.round(progress),
            actions: [...prev.actions, newAction],
        }));
    }
    
    function handleConfirmClick() {
        setIsAnimating(true);
        if (writtenWord.toLowerCase() === currentWord.name) {
            logUserAction(true);
            
            setIsWordVisible(true);
            setFeedback('happy');
            setInstructionText('Esatto! Continua così! ');
            setWordColor(activity_palettes.green.secondary);
            setWordBackground(activity_palettes.green.tertiary);
        } else {
            logUserAction(false);
            
            setIsWordVisible(true);
            setFeedback('sad');
            setInstructionText('Sei proprio sicuro? Attenzione!');
            setWordColor(activity_palettes.green.error_text);
            setWordBackground(activity_palettes.green.error_background);
        }
        if (currentWord.id < words.length - 1) {
            setTimeout(() => {
                updateButtonFlow(false, false, true);
                setIsAnimating(false);
            }, 1500);
        } else {
            setTimeout(() => {
                updateButtonFlow(false, true, false);
                setIsAnimating(false);
            }, 1500);
        }
    }
    
    function handleNextExerciseClick() {
        const temp = [...activityList];
        temp.shift();
        checkActivityStatus(currentActivity, temp).then(
            (response) => {
                try {
                    setActivityList(response);
                    redirectToExercise(response, navigate);
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
    
    function handleNextQuestionClick() {
        setFeedback('');
        setWordColor('white');
        setWordBackground('#3851C4');
        setWrittenWord('');
        updateButtonFlow(true, false, false);
        setInstructionText('Leggi la parola e scrivila nel riquadro');
        if (currentWord.id < words.length - 1) {
            setCurrentWord(words[currentWord.id + 1])
            setStepInfo(stepInfo + 1);
        }
    }
    
    const handleInputChange = (event) => {
        setWrittenWord(event.target.value);
    };
    
    useEffect(() => {
        if (currentWord.name !== '') {
            setIsAnimating(true);
            setIsWordVisible(true);
            const timer = setTimeout(() => {
                setIsWordVisible(false);
                setIsAnimating(false);
                setInstructionText('Che parola era? Prova a scriverla nel riquadro!');
            }, timeout);
            return () => clearTimeout(timer);
        }
    }, [currentWord]);
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then();
        }
    }, [exerciseLog]);
    
    if (loading) {
        return (
            <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
                <Spinner animation="border" variant="light"/>
            </div>
        );
    }
    
    return (
        <div
            className='generalActivitiesBackground custom-col-12 tablet-custom-col-12'
            style={{backgroundColor: BACKGROUND_STYLE}}
        >
            {flowButtons.startExercise ? (
                <div className='generalActivitiesConfirmButtonArea custom-row'>
                    <StartExerciseButton onClick={handleStartExerciseClick}/>
                </div>
            ) : (
                <>
                    <AnimationOverlay isAnimating={isAnimating}/>
                    <div className='generalActivitiesPageContent custom-col-11 tablet-custom-col-11'>
                        <div className={`generalActivitiesTopBarArea custom-row ${answered ? 'disabledElement' : ''}`}>
                            <TopBar levelInfo={levelInfo} stepInfo={stepInfo} maxSteps={maxSteps}/>
                            <Instructions hasAudio={false} instructionText={InstructionText} instructionAudioUrl={instructionAudioUrl}/>
                        </div>
                        <div className={`generalActivitiesGameElementsArea row ${answered ? 'disabledElement' : ''}`}>
                            <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                                <SadFeedback feedback={feedback.includes('sad')}/>
                            </div>
                            <div className='generalActivitiesColumnTwoColumnsLayout custom-col-4 tablet-custom-col-4'>
                                <div className='blueActivitiesArea blueActivitiesTargetTextArea center' style={{backgroundColor: isWordVisible ? 'white' : '#D2D2D5'}}>
                                    {isWordVisible ? currentWord.name : ''}
                                </div>
                            </div>
                            <div className='generalActivitiesColumnTwoColumnsLayout custom-col-4 tablet-custom-col-4'>
                                <div className='center blueActivitiesArea blueActivitiesEnabledInputTextArea' style={{backgroundColor: wordBackground}}>
                                    <input className='textFastReadArea' value={writtenWord} onChange={handleInputChange} style={{color: wordColor}}/>
                                </div>
                            </div>
                            <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                                <HappyFeedback feedback={feedback.includes('happy')}/>
                            </div>
                        </div>
                        <div className='generalActivitiesConfirmButtonArea custom-row'>
                            {flowButtons.confirm && <ConfirmButton onClick={handleConfirmClick}/>}
                            {flowButtons.nextExercise && <NextExerciseButton onClick={handleNextExerciseClick}/>}
                            {flowButtons.nextQuestion && <NextQuestionButton onClick={handleNextQuestionClick}/>}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default FastRead;
